import React from 'react';
import Modal from '../CommonComponents/Modal/Modal'

const ModalSizeGuide = ({isOpen, setIsOpen}) => {
  return (
    <Modal isOpen={isOpen} onClose={setIsOpen} className="modal--size-guide">
      <h2 className="modal__title">Size Guide</h2>
      <p className="modal__des">
        Sizing details can be found on either the left or right temple <br />
        (the arm at the side of the spectacle frame).
      </p>
      <img
        className="modal__img modal__img--number"
        src="https://static.lenskart.com/media/owndays/img/glasses-guide_number.webp"
        alt="Glasses guide number"
        loading="lazy"
      />
      <img
        className="modal__img modal__img--frame"
        src="https://static.lenskart.com/media/owndays/img/glasses-guide.webp"
        alt="Glasses guide"
        loading="lazy"
      />
      <img
        className="modal__img modal__img--text"
        src="https://static.lenskart.com/media/owndays/img/glasses-guide_text.webp"
        alt="Glasses guide text"
        loading="lazy"
      />
    </Modal>
  );
};

export default ModalSizeGuide;
